import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Gumball Poodle (b_1fc44661), pulled from Faire's
// live `GET /api/product-reviews/product/{product_token}` endpoint (review
// token pr_rk8vx2qbtc) — verbatim comment, real reviewer first name, location and rating.
export const review_gp5: FaireReviewEntity = {
  token: "review_gp5",
  type: "review",
  brandName: "Gumball Poodle",
  brandToken: "b_1fc44661",
  productToken: "p_cbc9pyx6r4",
  reviewType: "product",
  reviewerName: "Nichole",
  reviewerLocation: "Cabot, AR, United States",
  stars: 5,
  reviewText: "A woman in her 60s told my husband she was feral and well. So, of course I had to purchase them",
  reviewDate: "Jun 24, 2026",
  meta: {
    source: "api" as const,
    importedAt: "2026-10-12T05:40:00.000Z",
    importedBy: "entity-db-cli",
  },
};
